var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "#4B57E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "url(#paint0_linear_664_33908)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0049 11.9951H12.0049C11.8723 11.9951 11.7451 11.9424 11.6513 11.8487C11.5576 11.7549 11.5049 11.6277 11.5049 11.4951C11.5049 11.3625 11.5576 11.2353 11.6513 11.1416C11.7451 11.0478 11.8723 10.9951 12.0049 10.9951H20.5049C20.6375 10.9951 20.7647 10.9424 20.8584 10.8487C20.9522 10.7549 21.0049 10.6277 21.0049 10.4951C21.0049 10.3625 20.9522 10.2353 20.8584 10.1416C20.7647 10.0478 20.6375 9.99512 20.5049 9.99512H12.0049C11.6071 9.99512 11.2255 10.1532 10.9442 10.4345C10.6629 10.7158 10.5049 11.0973 10.5049 11.4951V19.4951C10.5049 19.8929 10.6629 20.2745 10.9442 20.5558C11.2255 20.8371 11.6071 20.9951 12.0049 20.9951H22.0049C22.2701 20.9951 22.5245 20.8898 22.712 20.7022C22.8995 20.5147 23.0049 20.2603 23.0049 19.9951V12.9951C23.0049 12.7299 22.8995 12.4755 22.712 12.288C22.5245 12.1005 22.2701 11.9951 22.0049 11.9951ZM22.0049 19.9951H12.0049C11.8723 19.9951 11.7451 19.9424 11.6513 19.8487C11.5576 19.7549 11.5049 19.6277 11.5049 19.4951V12.9095C11.6654 12.9664 11.8345 12.9954 12.0049 12.9951H22.0049V19.9951ZM19.0049 16.2451C19.0049 16.0968 19.0489 15.9518 19.1313 15.8284C19.2137 15.7051 19.3308 15.609 19.4679 15.5522C19.6049 15.4954 19.7557 15.4806 19.9012 15.5095C20.0467 15.5385 20.1803 15.6099 20.2852 15.7148C20.3901 15.8197 20.4615 15.9533 20.4905 16.0988C20.5194 16.2443 20.5046 16.3951 20.4478 16.5321C20.391 16.6692 20.2949 16.7863 20.1716 16.8687C20.0482 16.9511 19.9032 16.9951 19.7549 16.9951C19.556 16.9951 19.3652 16.9161 19.2246 16.7754C19.0839 16.6348 19.0049 16.444 19.0049 16.2451Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_33908",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B57E2",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.ffb19c5ae23cb4957262a3da73ecd7b3.svg";
export { ForwardRef as ReactComponent };